import { render, staticRenderFns } from "./CreateInventory.vue?vue&type=template&id=8ce0f6e0&scoped=true"
import script from "./CreateInventory.vue?vue&type=script&lang=js"
export * from "./CreateInventory.vue?vue&type=script&lang=js"
import style0 from "./CreateInventory.vue?vue&type=style&index=0&id=8ce0f6e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce0f6e0",
  null
  
)

export default component.exports